// extracted by mini-css-extract-plugin
export var banner = "_s2-0";
export var settingRow = "_s2-2";
export var titleIcon = "_s2-1";